export type ParsedErrorDescription =
  | Baidmatch
  | Profilanlage
  | Fehler
  | Freischaltung
  | Abbruch
  | ReauthRequired
  | InvalidCombination
  | MissingSession;

export interface Baidmatch {
  type: 'baidmatch';
  identity: string;
  actingOnBehalfOf: string;
}
export interface Profilanlage {
  type: 'profilanlage';
  baforprefix: string;
}
export interface Fehler {
  type: 'fehler';
  quelle: string;
  meldung: string;
}
export interface Freischaltung {
  type: 'freischaltung';
}
export interface Abbruch {
  type: 'abbruch';
}
export interface ReauthRequired {
  type: 'reauth_required';
}
export interface InvalidCombination {
  type: 'invalid_combination';
}
export interface MissingSession {
  type: 'missing_session';
}

export const parse = (desc: string): ParsedErrorDescription => {
  const usp = new URLSearchParams(desc);
  const type = usp.get('type');
  switch (type) {
    case 'profilanlage': {
      const baforprefix = usp.get('baforprefix');
      if (baforprefix) {
        return { type, baforprefix };
      }
      break;
    }
    case 'fehler': {
      const quelle = usp.get('quelle');
      const meldung = usp.get('meldung');
      return { type, quelle: quelle || 'unknown', meldung: meldung || desc };
    }
    case 'baidmatch': {
      const identity = usp.get('identity');
      const actingOnBehalfOf = usp.get('acting-on-behalf-of');
      if (identity && actingOnBehalfOf) {
        return { type, identity, actingOnBehalfOf: actingOnBehalfOf };
      }
      break;
    }
    case 'freischaltung':
    case 'abbruch':
    case 'reauth_required':
    case 'invalid_combination':
    case 'missing_session': {
      return { type };
    }
  }
  return genericError(desc);
};

const genericError = (meldung: string): Fehler => {
  return { type: 'fehler', quelle: 'unknown', meldung };
};
